export class AdaptiveRespuestaDTO {
    constructor(
        public order:       number,
        public idItem:      string,
        public respuesta:   string
    ) {}
}